export async function LoadCountries() {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/country',
        headers: { 
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}